export const pagination={
  TH:{
    items_per_page:"ข้อมูลต่อหน้า",
    show_item:"แสดงข้อมูล",
    from:"จาก",
    to:"ถึง",
    items:"ข้อมูล",
    showing_page:"หน้าที่แสดง"
  },
  EN:{
    items_per_page:"items per page",
    show_item:"show item",
    from:"from",
    to:"to",
    items:"items",
    showing_page:"showing page"

  }
}
